/**
 * Created by slava on 4/21/17.
 */

const TestPayments = function () {
    Payments.call(this, "test", {
        sdk: SdkManager.SDK_TEST
    });
};

TestPayments.prototype = Object.create(Payments.prototype);
TestPayments.prototype.constructor = TestPayments;

TestPayments.prototype._connect = function (callback) {
    setTimeout(() => {
        this.purchased = connector.dataLoader.load(SimpleDataLoader.TYPES.TESTPAYMENTS) || {};

        callback(connector.STATUS_CONNECTED);
    }, 1000);
};

TestPayments.prototype.save = function () {
    connector.dataLoader.save(SimpleDataLoader.TYPES.TESTPAYMENTS, this.purchased);
};

TestPayments.prototype.purchase = function (product, callback) {
    this.bus.trigger("updateFrameSize");

    const finish = (code, purchase, raw) => {
        setTimeout(() => {
            callback(code, purchase, raw);
            this.bus.trigger("updateFrameSize");
        }, TestPayments.PROCESS_TIMEOUT);
    };

    setTimeout(() => {
        TestPayments.showPurchaseDialog(product, { canRestore: product.type !== "subscription" }, (choice, restoreDelay, raw) => {
            if (choice === TestPayments.CHOICE_CANCEL) {
                console.log("TestPayments.Cancelled");
                finish(ERRORS.PURCHASE.CANCEL);
                return;
            }

            if (choice === TestPayments.CHOICE_ERROR) {
                finish(ERRORS.PURCHASE.UNKNOWN, undefined, raw);
                return;
            }

            const purchase = this.createPurchase(Date.now(), product, {
                purchaseToken: "test_token"
            });
            this.purchased[purchase.paymentId] = purchase;
            this.save();

            if (choice === TestPayments.CHOICE_RESTORE) {
                // the receipt is kept, the first validate stays pending and a restore delivers it after the chosen delay
                this.pendingValidate = purchase.paymentId;
                setTimeout(() => connector.payments.restoreCallback(), restoreDelay);
            }

            finish(connector.CODE_SUCCEED, purchase);
        });
    }, 1000);
};

TestPayments.prototype.validate = function (purchase, callback) {
    if (this.pendingValidate === purchase.paymentId) {
        delete this.pendingValidate;
        callback(connector.CODE_CANCELLED);
        return;
    }

    Payments.prototype.validate.call(this, purchase, callback);
};

// staging replacement for confirm(): the product with its price, the outcome to simulate and the restore delay
TestPayments.showPurchaseDialog = function (product, options, callback) {
    const create = (tag, style, parent) => {
        const element = document.createElement(tag);
        Object.assign(element.style, style);
        parent.appendChild(element);
        return element;
    };

    const overlay = create("div", {
        position: "fixed",
        left: "0",
        top: "0",
        right: "0",
        bottom: "0",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: "1000",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontFamily: "sans-serif"
    }, document.body);

    const form = create("div", {
        backgroundColor: "#fff",
        padding: "20px",
        borderRadius: "8px",
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "12px",
        maxWidth: "420px",
        width: "90%",
        maxHeight: "90vh",
        boxSizing: "border-box",
        overflowY: "auto"
    }, overlay);

    if (product.image) {
        const image = create("img", { maxWidth: "160px", maxHeight: "min(160px, 25vh)" }, form);
        image.src = product.image;
        image.onerror = () => form.removeChild(image);
    }

    const action = product.type === "subscription" ? `Activate ${product.trial ? "trial " : ""}subscription` : "Buy";

    create("div", { fontSize: "20px", fontWeight: "bold" }, form).textContent = product.title;
    if (product.description) {
        create("div", { fontSize: "14px", color: "#555", wordBreak: "break-word" }, form).textContent = product.description;
    }
    create("div", { fontSize: "18px" }, form).textContent = `${action} for ${product.textPrice}`;

    const controlStyle = { fontSize: "15px", padding: "6px 8px" };
    const rowStyle = {
        display: "flex",
        alignItems: "center",
        gap: "8px",
        fontSize: "15px"
    };

    const select = create("select", controlStyle, form);
    const outcomes = [
        { choice: TestPayments.CHOICE_BUY, text: "Payment succeeds" },
        { choice: TestPayments.CHOICE_ERROR, text: "Payment error" },
        { choice: TestPayments.CHOICE_RESTORE, text: "Payment fails, restored later", hidden: !options.canRestore }
    ];
    outcomes.filter((item) => !item.hidden).forEach((item) => {
        const option = create("option", {}, select);
        option.value = item.choice;
        option.textContent = item.text;
    });
    const remembered = TestPayments.lastChoice;
    select.value = remembered && (remembered !== TestPayments.CHOICE_RESTORE || options.canRestore) ? remembered : TestPayments.CHOICE_BUY;

    const delayRow = create("label", rowStyle, form);
    delayRow.textContent = "Restore after";
    const delay = create("input", { ...controlStyle, width: "60px" }, delayRow);
    delay.type = "number";
    delay.min = "1";
    delay.value = TestPayments.lastRestoreDelay || TestPayments.RESTORE_DELAY / 1000;
    create("span", {}, delayRow).textContent = "seconds";

    const rawRow = create("label", rowStyle, form);
    rawRow.textContent = "Raw answer";
    const rawError = create("input", { ...controlStyle, width: "80px" }, rawRow);
    rawError.placeholder = "error";
    const rawMessage = create("input", { ...controlStyle, width: "140px" }, rawRow);
    rawMessage.placeholder = "message";

    const updateRows = () => {
        delayRow.style.display = select.value === TestPayments.CHOICE_RESTORE ? "flex" : "none";
        rawRow.style.display = select.value === TestPayments.CHOICE_ERROR ? "flex" : "none";
    };
    select.onchange = updateRows;
    updateRows();

    const buttons = create("div", { display: "flex", gap: "10px" }, form);

    const close = (choice) => {
        document.body.removeChild(overlay);
        callback(choice, Math.max(1, Number(delay.value) || 1) * 1000, { error: rawError.value, message: rawMessage.value });
    };

    [
        { text: action, color: "#28A745", onclick: () => close(select.value) },
        { text: "Cancel", color: "#6C757D", onclick: () => close(TestPayments.CHOICE_CANCEL) }
    ].forEach((item) => {
        const button = create("button", {
            backgroundColor: item.color,
            color: "white",
            border: "none",
            padding: "10px 16px",
            borderRadius: "4px",
            cursor: "pointer",
            fontSize: "15px"
        }, buttons);
        button.textContent = item.text;
        button.onclick = () => {
            TestPayments.lastChoice = select.value;
            TestPayments.lastRestoreDelay = Number(delay.value);
            item.onclick();
        };
    });
};

TestPayments.prototype.restore = function (callback) {
    const purchase = Object.values(this.purchased)[0];
    if (purchase) {
        callback(connector.CODE_SUCCEED, purchase);
    } else {
        callback(connector.CODE_FAILED);
    }
};

TestPayments.prototype.consume = function (purchase, callback) {
    if (purchase && purchase.paymentId) {
        delete this.purchased[purchase.paymentId];
        this.save();
    }

    callback(connector.CODE_SUCCEED);
};

TestPayments.isAppropriate = function () {
    return TestSocial.isAppropriate();
};

TestPayments.PROCESS_TIMEOUT = 0;
TestPayments.RESTORE_DELAY = 5000;

TestPayments.CHOICE_BUY = "buy";
TestPayments.CHOICE_ERROR = "error";
TestPayments.CHOICE_RESTORE = "restore";
TestPayments.CHOICE_CANCEL = "cancel";